import { Component, OnInit } from '@angular/core';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { BrokerAuditDeclarationService } from '../broker-audit-declaration.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-start-audit-declaration',
  templateUrl: './start-audit-declaration.component.html',
  styleUrls: ['./start-audit-declaration.component.css']
})
export class StartAuditDeclarationComponent implements OnInit {

  startFunction: StartFunctionResponseModel = {};
  title: string = "Broker Audit Declaration";

  constructor(private currentPageWatcher: CurrentPageWatcherService,
    private router: Router,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private brokerAuditDeclarationService: BrokerAuditDeclarationService) {

    this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.title = this.startFunction.Workflow.WorkflowDisplayName;
      this.brokerAuditDeclarationService.brokerAuditDeclarationWorkflowModel = this.startFunction.Workflow;

    }
   }

  ngOnInit() {

    this.currentPageWatcher.pageChanged().emit(this.title);

  }

  continue(){
    this.router.navigate(['/brokerageInformation']).then(() => {
      this.startFunctionService.getNotifyStepInProgress().emit(true);

    });
  }

  goBackHome() {
    this.router.navigate(['/home']);
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/broker-audit-declaration/start-audit-declaration/start-audit-declaration.component.ts